import React from "react";
import { siteData } from "../mock";

export default function Process() {
  return (
    <section className="bg-[#f0e4d5]/50 py-24">
      <div className="container-tight">
        <div className="max-w-2xl mb-14">
          <span className="chip mb-4">Déroulement</span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
            À quoi s'attendre
          </h2>
          <p className="mt-4 text-[#4a4642] text-lg">
            Un processus clair et bienveillant, pensé pour votre confort et vos résultats.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {siteData.process.map((p, i) => (
            <div
              key={i}
              className="relative bg-white rounded-3xl p-7 border border-[#e8e0d5] hover:border-[#d97757]/40 transition-colors"
            >
              <div className="absolute top-6 right-6 font-serif text-5xl font-medium text-[#d97757]/25 leading-none">
                {p.step}
              </div>
              <div className="w-11 h-11 rounded-full bg-[#c76d4b] text-white flex items-center justify-center font-serif font-semibold mb-5">
                {p.step}
              </div>
              <h3 className="font-serif text-xl font-medium text-[#1a1815] mb-2">{p.title}</h3>
              <p className="text-[#4a4642] text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
